import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './state/store'
import ManageLib from '@lib'
import applications from '@lib/applications'
import packageJson from '../package.json'
import modal from '@lib/components/modal'

Vue.use(ManageLib, {
  config: applications.super,
  packageJson,
  router,
  store,
})

Vue.use(modal)

new Vue({
  router,
  store,
  props: {
    title: {
      type: String,
      default: process.env.VUE_APP_NAME || 'Admin',
    },
  },
  render: h => h(App),
}).$mount('#app')
